/**
 * Tab-specific localStorage utilities to prevent conflicts between tabs
 */

// Generate unique tab ID for this session
const getTabId = () => {
    if (!window.tabId) {
        window.tabId = `tab_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
        console.log('Generated new tab ID:', window.tabId);
    }
    return window.tabId;
};

/**
 * Get item from localStorage with tab-specific key
 * @param {string} key - The storage key
 * @returns {string|null} - Stored value or null
 */
export const getTabStorage = (key) => {
    const tabSpecificKey = `${key}_${getTabId()}`;
    return localStorage.getItem(tabSpecificKey);
};

/**
 * Set item in localStorage with tab-specific key
 * @param {string} key - The storage key
 * @param {string} value - The value to store
 */
export const setTabStorage = (key, value) => {
    const tabSpecificKey = `${key}_${getTabId()}`;
    localStorage.setItem(tabSpecificKey, value);
};

/**
 * Remove item from localStorage with tab-specific key
 * @param {string} key - The storage key
 */
export const removeTabStorage = (key) => {
    const tabSpecificKey = `${key}_${getTabId()}`;
    localStorage.removeItem(tabSpecificKey);
};

/**
 * Clean up old tab-specific storage items (optional cleanup)
 * Call this when the app starts to clean up old tab data
 */
export const cleanupOldTabStorage = () => {
    const keys = Object.keys(localStorage);
    const currentTabId = getTabId();
    
    keys.forEach(key => {
        // If key ends with a tab ID pattern but not the current one
        const tabPattern = /_tab_\d+_[a-z0-9]+$/;
        if (tabPattern.test(key) && !key.endsWith(currentTabId)) {
            localStorage.removeItem(key);
        }
    });
};